module.exports = __webpack_public_path__ + "static/media/dashboards-metrics.b2684259.svg";